import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { ErrorService } from '../helpers/errorService';
import { IRMSPlanSummary } from '../models/rmsPlanSummary';

@Injectable({
  providedIn: 'root'
})
export class RMSPlanSummaryService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getRMSPlanSummaryByCaseId(caseId: string): Observable<IRMSPlanSummary> {
        const url = environment.apiBaseUrl + endpoints.getRMSPlanSummaryByCaseId.replace(':caseId', caseId);
        return this.http.get<IRMSPlanSummary>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    updateRMSPlanSummary(data: IRMSPlanSummary): Observable<any> {
        const url = environment.apiBaseUrl + endpoints.updateRMSPlanSummary;
        return this.http.post(url, data).pipe(
            catchError(this.errorService.handleSavingError)
        );
    }
}